// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/registration/stakeholders/firstparty/v1/stakeholder.proto

/* oxlint-disable */
import { ApiTimestamp } from "../../../../../google/protobuf/timestamp";

/** KYC provider used for stakeholder verification */
export const ApiKycProvider = {
  /** KYC_PROVIDER_UNSPECIFIED - Unspecified KYC provider */
  KYC_PROVIDER_UNSPECIFIED: "KYC_PROVIDER_UNSPECIFIED",
  /**
   * Onfido KYC provider
   */
  onfido: "onfido",
  /**
   * Qonto internal KYC provider
   */
  qonto: "qonto",
  /**
   * IDnow video identification KYC provider
   */
  idnow_videoident: "idnow_videoident",
  /**
   * Fourthline KYC provider
   */
  fourthline: "fourthline",
  /**
   * INPI KYC provider
   */
  inpi: "inpi",
} as const;

export type ApiKycProvider = typeof ApiKycProvider[keyof typeof ApiKycProvider];

export namespace ApiKycProvider {
  export type KYC_PROVIDER_UNSPECIFIED = typeof ApiKycProvider.KYC_PROVIDER_UNSPECIFIED;
  export type onfido = typeof ApiKycProvider.onfido;
  export type qonto = typeof ApiKycProvider.qonto;
  export type idnow_videoident = typeof ApiKycProvider.idnow_videoident;
  export type fourthline = typeof ApiKycProvider.fourthline;
  export type inpi = typeof ApiKycProvider.inpi;
}

export function apiKycProviderFromJSON(object: any): ApiKycProvider {
  switch (object) {
    case 0:
    case "KYC_PROVIDER_UNSPECIFIED":
      return ApiKycProvider.KYC_PROVIDER_UNSPECIFIED;
    case 1:
    case "onfido":
      return ApiKycProvider.onfido;
    case 2:
    case "qonto":
      return ApiKycProvider.qonto;
    case 3:
    case "idnow_videoident":
      return ApiKycProvider.idnow_videoident;
    case 4:
    case "fourthline":
      return ApiKycProvider.fourthline;
    case 5:
    case "inpi":
      return ApiKycProvider.inpi;
    default:
      return ApiKycProvider.KYC_PROVIDER_UNSPECIFIED;
  }
}

export function apiKycProviderToJSON(object: ApiKycProvider): string {
  switch (object) {
    case ApiKycProvider.KYC_PROVIDER_UNSPECIFIED:
      return "KYC_PROVIDER_UNSPECIFIED";
    case ApiKycProvider.onfido:
      return "onfido";
    case ApiKycProvider.qonto:
      return "qonto";
    case ApiKycProvider.idnow_videoident:
      return "idnow_videoident";
    case ApiKycProvider.fourthline:
      return "fourthline";
    case ApiKycProvider.inpi:
      return "inpi";
    default:
      return "KYC_PROVIDER_UNSPECIFIED";
  }
}

/** Gender of the stakeholder */
export const ApiGender = {
  /** GENDER_UNSPECIFIED - Unspecified gender */
  GENDER_UNSPECIFIED: "GENDER_UNSPECIFIED",
  /**
   * Male gender
   */
  male: "male",
  /**
   * Female gender
   */
  female: "female",
} as const;

export type ApiGender = typeof ApiGender[keyof typeof ApiGender];

export namespace ApiGender {
  export type GENDER_UNSPECIFIED = typeof ApiGender.GENDER_UNSPECIFIED;
  export type male = typeof ApiGender.male;
  export type female = typeof ApiGender.female;
}

export function apiGenderFromJSON(object: any): ApiGender {
  switch (object) {
    case 0:
    case "GENDER_UNSPECIFIED":
      return ApiGender.GENDER_UNSPECIFIED;
    case 1:
    case "male":
      return ApiGender.male;
    case 2:
    case "female":
      return ApiGender.female;
    default:
      return ApiGender.GENDER_UNSPECIFIED;
  }
}

export function apiGenderToJSON(object: ApiGender): string {
  switch (object) {
    case ApiGender.GENDER_UNSPECIFIED:
      return "GENDER_UNSPECIFIED";
    case ApiGender.male:
      return "male";
    case ApiGender.female:
      return "female";
    default:
      return "GENDER_UNSPECIFIED";
  }
}

/** UBO provider verification status */
export const ApiUboProviderStatus = {
  /** UBO_PROVIDER_STATUS_UNSPECIFIED - Unspecified UBO provider status */
  UBO_PROVIDER_STATUS_UNSPECIFIED: "UBO_PROVIDER_STATUS_UNSPECIFIED",
  /**
   * UBO provider has confirmed the stakeholder
   */
  confirmed: "confirmed",
  /**
   * UBO provider has not yet confirmed the stakeholder
   */
  unconfirmed: "unconfirmed",
} as const;

export type ApiUboProviderStatus = typeof ApiUboProviderStatus[keyof typeof ApiUboProviderStatus];

export namespace ApiUboProviderStatus {
  export type UBO_PROVIDER_STATUS_UNSPECIFIED = typeof ApiUboProviderStatus.UBO_PROVIDER_STATUS_UNSPECIFIED;
  export type confirmed = typeof ApiUboProviderStatus.confirmed;
  export type unconfirmed = typeof ApiUboProviderStatus.unconfirmed;
}

export function apiUboProviderStatusFromJSON(object: any): ApiUboProviderStatus {
  switch (object) {
    case 0:
    case "UBO_PROVIDER_STATUS_UNSPECIFIED":
      return ApiUboProviderStatus.UBO_PROVIDER_STATUS_UNSPECIFIED;
    case 1:
    case "confirmed":
      return ApiUboProviderStatus.confirmed;
    case 2:
    case "unconfirmed":
      return ApiUboProviderStatus.unconfirmed;
    default:
      return ApiUboProviderStatus.UBO_PROVIDER_STATUS_UNSPECIFIED;
  }
}

export function apiUboProviderStatusToJSON(object: ApiUboProviderStatus): string {
  switch (object) {
    case ApiUboProviderStatus.UBO_PROVIDER_STATUS_UNSPECIFIED:
      return "UBO_PROVIDER_STATUS_UNSPECIFIED";
    case ApiUboProviderStatus.confirmed:
      return "confirmed";
    case ApiUboProviderStatus.unconfirmed:
      return "unconfirmed";
    default:
      return "UBO_PROVIDER_STATUS_UNSPECIFIED";
  }
}

/** Role of the stakeholder within the organization */
export const ApiRole = {
  /** ROLE_UNSPECIFIED - Unspecified role */
  ROLE_UNSPECIFIED: "ROLE_UNSPECIFIED",
  /**
   * Owner role
   */
  owner: "owner",
  /**
   * Administrator role
   */
  admin: "admin",
  /**
   * Employee role
   */
  employee: "employee",
  /**
   * Reporting role
   */
  reporting: "reporting",
} as const;

export type ApiRole = typeof ApiRole[keyof typeof ApiRole];

export namespace ApiRole {
  export type ROLE_UNSPECIFIED = typeof ApiRole.ROLE_UNSPECIFIED;
  export type owner = typeof ApiRole.owner;
  export type admin = typeof ApiRole.admin;
  export type employee = typeof ApiRole.employee;
  export type reporting = typeof ApiRole.reporting;
}

export function apiRoleFromJSON(object: any): ApiRole {
  switch (object) {
    case 0:
    case "ROLE_UNSPECIFIED":
      return ApiRole.ROLE_UNSPECIFIED;
    case 1:
    case "owner":
      return ApiRole.owner;
    case 2:
    case "admin":
      return ApiRole.admin;
    case 3:
    case "employee":
      return ApiRole.employee;
    case 4:
    case "reporting":
      return ApiRole.reporting;
    default:
      return ApiRole.ROLE_UNSPECIFIED;
  }
}

export function apiRoleToJSON(object: ApiRole): string {
  switch (object) {
    case ApiRole.ROLE_UNSPECIFIED:
      return "ROLE_UNSPECIFIED";
    case ApiRole.owner:
      return "owner";
    case ApiRole.admin:
      return "admin";
    case ApiRole.employee:
      return "employee";
    case ApiRole.reporting:
      return "reporting";
    default:
      return "ROLE_UNSPECIFIED";
  }
}

/** Stakeholder represents a person associated with an organization during registration */
export interface ApiStakeholder {
  /** Unique identifier of the stakeholder */
  readonly id: string;
  /** Organization ID associated with the stakeholder */
  readonly organizationId: string;
  /** Array of document IDs associated with the stakeholder */
  readonly documentIds: readonly string[];
  /** The title the stakeholder holds in their organization */
  readonly humanizedTitle: string;
  /** The KYC provider against which the stakeholder has to validate */
  readonly kycProvider?:
    | ApiKycProvider
    | null
    | undefined;
  /** The KYC provider remote resource identifier */
  readonly kycProviderId?:
    | string
    | null
    | undefined;
  /** Creation timestamp */
  readonly createdAt:
    | Date
    | null;
  /** The title-key the stakeholder holds in their organization */
  readonly title?:
    | string
    | null
    | undefined;
  /** The gender of the stakeholder */
  readonly gender?:
    | ApiGender
    | null
    | undefined;
  /** The first name of the stakeholder */
  readonly firstName?:
    | string
    | null
    | undefined;
  /** The last name of the stakeholder */
  readonly lastName?:
    | string
    | null
    | undefined;
  /** The email of the stakeholder */
  readonly email?:
    | string
    | null
    | undefined;
  /** The phone number of the stakeholder */
  readonly phoneNumber?:
    | string
    | null
    | undefined;
  /** The locale setting of the stakeholder */
  readonly locale?:
    | string
    | null
    | undefined;
  /** The timezone setting of the stakeholder */
  readonly timezone?:
    | string
    | null
    | undefined;
  /** The birthdate of the stakeholder */
  readonly birthdate?:
    | Date
    | null
    | undefined;
  /** The 1st line of the address of the stakeholder */
  readonly addressLine1?:
    | string
    | null
    | undefined;
  /** The 2nd line of the address of the stakeholder */
  readonly addressLine2?:
    | string
    | null
    | undefined;
  /** The zipcode of the address of the stakeholder */
  readonly addressZipcode?:
    | string
    | null
    | undefined;
  /** The city of the address of the stakeholder */
  readonly addressCity?:
    | string
    | null
    | undefined;
  /** The country of the address of the stakeholder */
  readonly addressCountry?:
    | string
    | null
    | undefined;
  /** The birth zipcode of the stakeholder */
  readonly birthZipcode?:
    | string
    | null
    | undefined;
  /** The birth city of the stakeholder */
  readonly birthCity?:
    | string
    | null
    | undefined;
  /** The birth country of the stakeholder */
  readonly birthCountry?:
    | string
    | null
    | undefined;
  /** The nationality of the stakeholder */
  readonly nationality?:
    | string
    | null
    | undefined;
  /** The role of the stakeholder */
  readonly role?:
    | ApiRole
    | null
    | undefined;
  /** Whether the stakeholder is a shareholder */
  readonly shareholder?:
    | boolean
    | null
    | undefined;
  /** Capital amount for FR k-deposit, in cents */
  readonly capitalAmountCents?:
    | number
    | null
    | undefined;
  /** Whether the stakeholder gave power of attorney */
  readonly gavePower?:
    | boolean
    | null
    | undefined;
  /** Whether the stakeholder is empowered */
  readonly powered?:
    | boolean
    | null
    | undefined;
  /** Whether the stakeholder is a UBO */
  readonly ubo?:
    | boolean
    | null
    | undefined;
  /** Whether the stakeholder is a corporate officer */
  readonly corporateOfficer?:
    | boolean
    | null
    | undefined;
  /** The Italian fiscal code */
  readonly italianFiscalCode?:
    | string
    | null
    | undefined;
  /** Whether this person is a tax payer in the United States */
  readonly usTaxPayer?:
    | boolean
    | null
    | undefined;
  /** Whether this person is a tax payer in country different from the legal country of the organization */
  readonly taxPayerOutsideLegalCountry?:
    | boolean
    | null
    | undefined;
  /** Whether the domicile address is the same as the address */
  readonly domicileSameAsResidence?:
    | boolean
    | null
    | undefined;
  /** The 1st line of the domicile address of the stakeholder */
  readonly domicileLine1?:
    | string
    | null
    | undefined;
  /** The 2nd line of the domicile address of the stakeholder */
  readonly domicileLine2?:
    | string
    | null
    | undefined;
  /** The zipcode of the domicile address of the stakeholder */
  readonly domicileZipcode?:
    | string
    | null
    | undefined;
  /** The city of the domicile address of the stakeholder */
  readonly domicileCity?:
    | string
    | null
    | undefined;
  /** The country of the domicile address of the stakeholder */
  readonly domicileCountry?:
    | string
    | null
    | undefined;
  /** The sources of wealth of the stakeholder */
  readonly sourcesOfWealth: readonly string[];
  /** The freeform text for the stakeholder's sources of wealth */
  readonly sourcesOfWealthOther?:
    | string
    | null
    | undefined;
  /** Whether the stakeholder has specified any additional sources of wealth */
  readonly hasSourcesOfWealth?:
    | boolean
    | null
    | undefined;
  /** Whether the stakeholder is a politically exposed person (PEP) */
  readonly politicallyExposedPerson?:
    | boolean
    | null
    | undefined;
  /** The nationalities of the stakeholder (ISO 3166-1 alpha-2 codes) */
  readonly nationalities: readonly string[];
  /** Whether the stakeholder is a US person (FATCA compliance) */
  readonly usPerson?:
    | boolean
    | null
    | undefined;
  /** Whether the stakeholder has declared themselves as a politically exposed person */
  readonly selfPepDeclaration?:
    | boolean
    | null
    | undefined;
  /** The tax identification number in a country other than the legal country */
  readonly otherTaxIdentificationNumber?:
    | string
    | null
    | undefined;
  /** The tax residency country other than the legal country (ISO 3166-1 alpha-2) */
  readonly otherTaxResidencyCountry?:
    | string
    | null
    | undefined;
  /** The US tax identification number */
  readonly usTaxIdentificationNumber?:
    | string
    | null
    | undefined;
  /** Whether the stakeholder was created by a data provider (e.g. Creditsafe) */
  readonly providerCreated?:
    | boolean
    | null
    | undefined;
  /** The identity ID of the stakeholder */
  readonly identityId?:
    | string
    | null
    | undefined;
  /** The UBO connection to the organization */
  readonly uboConnectionToOrganization?:
    | string
    | null
    | undefined;
  /** The raw UBO connection to the organization */
  readonly uboConnectionToOrganizationRaw?:
    | string
    | null
    | undefined;
  /** The UBO provider verification status */
  readonly uboProviderStatus?:
    | ApiUboProviderStatus
    | null
    | undefined;
  /** Countries where the stakeholder has significant relationships (ISO 3166-1 alpha-2 codes) */
  readonly countriesOfSignificantRelationship: readonly string[];
  /** Country of predominant economic activity (ISO 3166-1 alpha-2) */
  readonly countryOfPredominantEconomicActivity?: string | null | undefined;
}

export const ApiStakeholder: MessageFns<ApiStakeholder> = {
  fromJSON(object: any): ApiStakeholder {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      organizationId: isSet(object.organization_id) ? globalThis.String(object.organization_id) : "",
      documentIds: globalThis.Array.isArray(object?.document_ids)
        ? object.document_ids.map((e: any) => globalThis.String(e))
        : [],
      humanizedTitle: isSet(object.humanized_title) ? globalThis.String(object.humanized_title) : "",
      kycProvider: isSet(object.kyc_provider) ? apiKycProviderFromJSON(object.kyc_provider) : null,
      kycProviderId: isSet(object.kyc_provider_id) ? globalThis.String(object.kyc_provider_id) : null,
      createdAt: isSet(object.created_at) ? fromJsonTimestamp(object.created_at) : null,
      title: isSet(object.title) ? globalThis.String(object.title) : null,
      gender: isSet(object.gender) ? apiGenderFromJSON(object.gender) : null,
      firstName: isSet(object.first_name) ? globalThis.String(object.first_name) : null,
      lastName: isSet(object.last_name) ? globalThis.String(object.last_name) : null,
      email: isSet(object.email) ? globalThis.String(object.email) : null,
      phoneNumber: isSet(object.phone_number) ? globalThis.String(object.phone_number) : null,
      locale: isSet(object.locale) ? globalThis.String(object.locale) : null,
      timezone: isSet(object.timezone) ? globalThis.String(object.timezone) : null,
      birthdate: isSet(object.birthdate) ? fromJsonTimestamp(object.birthdate) : null,
      addressLine1: isSet(object.address_line_1) ? globalThis.String(object.address_line_1) : null,
      addressLine2: isSet(object.address_line_2) ? globalThis.String(object.address_line_2) : null,
      addressZipcode: isSet(object.address_zipcode) ? globalThis.String(object.address_zipcode) : null,
      addressCity: isSet(object.address_city) ? globalThis.String(object.address_city) : null,
      addressCountry: isSet(object.address_country) ? globalThis.String(object.address_country) : null,
      birthZipcode: isSet(object.birth_zipcode) ? globalThis.String(object.birth_zipcode) : null,
      birthCity: isSet(object.birth_city) ? globalThis.String(object.birth_city) : null,
      birthCountry: isSet(object.birth_country) ? globalThis.String(object.birth_country) : null,
      nationality: isSet(object.nationality) ? globalThis.String(object.nationality) : null,
      role: isSet(object.role) ? apiRoleFromJSON(object.role) : null,
      shareholder: isSet(object.shareholder) ? globalThis.Boolean(object.shareholder) : null,
      capitalAmountCents: isSet(object.capital_amount_cents) ? globalThis.Number(object.capital_amount_cents) : null,
      gavePower: isSet(object.gave_power) ? globalThis.Boolean(object.gave_power) : null,
      powered: isSet(object.powered) ? globalThis.Boolean(object.powered) : null,
      ubo: isSet(object.ubo) ? globalThis.Boolean(object.ubo) : null,
      corporateOfficer: isSet(object.corporate_officer) ? globalThis.Boolean(object.corporate_officer) : null,
      italianFiscalCode: isSet(object.italian_fiscal_code) ? globalThis.String(object.italian_fiscal_code) : null,
      usTaxPayer: isSet(object.us_tax_payer) ? globalThis.Boolean(object.us_tax_payer) : null,
      taxPayerOutsideLegalCountry: isSet(object.tax_payer_outside_legal_country)
        ? globalThis.Boolean(object.tax_payer_outside_legal_country)
        : null,
      domicileSameAsResidence: isSet(object.domicile_same_as_residence)
        ? globalThis.Boolean(object.domicile_same_as_residence)
        : null,
      domicileLine1: isSet(object.domicile_line_1) ? globalThis.String(object.domicile_line_1) : null,
      domicileLine2: isSet(object.domicile_line_2) ? globalThis.String(object.domicile_line_2) : null,
      domicileZipcode: isSet(object.domicile_zipcode) ? globalThis.String(object.domicile_zipcode) : null,
      domicileCity: isSet(object.domicile_city) ? globalThis.String(object.domicile_city) : null,
      domicileCountry: isSet(object.domicile_country) ? globalThis.String(object.domicile_country) : null,
      sourcesOfWealth: globalThis.Array.isArray(object?.sources_of_wealth)
        ? object.sources_of_wealth.map((e: any) => globalThis.String(e))
        : [],
      sourcesOfWealthOther: isSet(object.sources_of_wealth_other)
        ? globalThis.String(object.sources_of_wealth_other)
        : null,
      hasSourcesOfWealth: isSet(object.has_sources_of_wealth) ? globalThis.Boolean(object.has_sources_of_wealth) : null,
      politicallyExposedPerson: isSet(object.politically_exposed_person)
        ? globalThis.Boolean(object.politically_exposed_person)
        : null,
      nationalities: globalThis.Array.isArray(object?.nationalities)
        ? object.nationalities.map((e: any) => globalThis.String(e))
        : [],
      usPerson: isSet(object.us_person) ? globalThis.Boolean(object.us_person) : null,
      selfPepDeclaration: isSet(object.self_pep_declaration) ? globalThis.Boolean(object.self_pep_declaration) : null,
      otherTaxIdentificationNumber: isSet(object.other_tax_identification_number)
        ? globalThis.String(object.other_tax_identification_number)
        : null,
      otherTaxResidencyCountry: isSet(object.other_tax_residency_country)
        ? globalThis.String(object.other_tax_residency_country)
        : null,
      usTaxIdentificationNumber: isSet(object.us_tax_identification_number)
        ? globalThis.String(object.us_tax_identification_number)
        : null,
      providerCreated: isSet(object.provider_created) ? globalThis.Boolean(object.provider_created) : null,
      identityId: isSet(object.identity_id) ? globalThis.String(object.identity_id) : null,
      uboConnectionToOrganization: isSet(object.ubo_connection_to_organization)
        ? globalThis.String(object.ubo_connection_to_organization)
        : null,
      uboConnectionToOrganizationRaw: isSet(object.ubo_connection_to_organization_raw)
        ? globalThis.String(object.ubo_connection_to_organization_raw)
        : null,
      uboProviderStatus: isSet(object.ubo_provider_status)
        ? apiUboProviderStatusFromJSON(object.ubo_provider_status)
        : null,
      countriesOfSignificantRelationship: globalThis.Array.isArray(object?.countries_of_significant_relationship)
        ? object.countries_of_significant_relationship.map((e: any) => globalThis.String(e))
        : [],
      countryOfPredominantEconomicActivity: isSet(object.country_of_predominant_economic_activity)
        ? globalThis.String(object.country_of_predominant_economic_activity)
        : null,
    };
  },

  toJSON(message: ApiStakeholder): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.organizationId !== undefined && message.organizationId !== null) {
      obj.organization_id = message.organizationId;
    }
    if (message.documentIds?.length) {
      obj.document_ids = message.documentIds;
    }
    if (message.humanizedTitle !== undefined && message.humanizedTitle !== null) {
      obj.humanized_title = message.humanizedTitle;
    }
    if (message.kycProvider !== undefined && message.kycProvider !== null) {
      obj.kyc_provider = apiKycProviderToJSON(message.kycProvider);
    }
    if (message.kycProviderId !== undefined && message.kycProviderId !== null) {
      obj.kyc_provider_id = message.kycProviderId;
    }
    if (message.createdAt !== undefined && message.createdAt !== null) {
      obj.created_at = message.createdAt.toISOString();
    }
    if (message.title !== undefined && message.title !== null) {
      obj.title = message.title;
    }
    if (message.gender !== undefined && message.gender !== null) {
      obj.gender = apiGenderToJSON(message.gender);
    }
    if (message.firstName !== undefined && message.firstName !== null) {
      obj.first_name = message.firstName;
    }
    if (message.lastName !== undefined && message.lastName !== null) {
      obj.last_name = message.lastName;
    }
    if (message.email !== undefined && message.email !== null) {
      obj.email = message.email;
    }
    if (message.phoneNumber !== undefined && message.phoneNumber !== null) {
      obj.phone_number = message.phoneNumber;
    }
    if (message.locale !== undefined && message.locale !== null) {
      obj.locale = message.locale;
    }
    if (message.timezone !== undefined && message.timezone !== null) {
      obj.timezone = message.timezone;
    }
    if (message.birthdate !== undefined && message.birthdate !== null) {
      obj.birthdate = message.birthdate.toISOString();
    }
    if (message.addressLine1 !== undefined && message.addressLine1 !== null) {
      obj.address_line_1 = message.addressLine1;
    }
    if (message.addressLine2 !== undefined && message.addressLine2 !== null) {
      obj.address_line_2 = message.addressLine2;
    }
    if (message.addressZipcode !== undefined && message.addressZipcode !== null) {
      obj.address_zipcode = message.addressZipcode;
    }
    if (message.addressCity !== undefined && message.addressCity !== null) {
      obj.address_city = message.addressCity;
    }
    if (message.addressCountry !== undefined && message.addressCountry !== null) {
      obj.address_country = message.addressCountry;
    }
    if (message.birthZipcode !== undefined && message.birthZipcode !== null) {
      obj.birth_zipcode = message.birthZipcode;
    }
    if (message.birthCity !== undefined && message.birthCity !== null) {
      obj.birth_city = message.birthCity;
    }
    if (message.birthCountry !== undefined && message.birthCountry !== null) {
      obj.birth_country = message.birthCountry;
    }
    if (message.nationality !== undefined && message.nationality !== null) {
      obj.nationality = message.nationality;
    }
    if (message.role !== undefined && message.role !== null) {
      obj.role = apiRoleToJSON(message.role);
    }
    if (message.shareholder !== undefined && message.shareholder !== null) {
      obj.shareholder = message.shareholder;
    }
    if (message.capitalAmountCents !== undefined && message.capitalAmountCents !== null) {
      obj.capital_amount_cents = Math.round(message.capitalAmountCents);
    }
    if (message.gavePower !== undefined && message.gavePower !== null) {
      obj.gave_power = message.gavePower;
    }
    if (message.powered !== undefined && message.powered !== null) {
      obj.powered = message.powered;
    }
    if (message.ubo !== undefined && message.ubo !== null) {
      obj.ubo = message.ubo;
    }
    if (message.corporateOfficer !== undefined && message.corporateOfficer !== null) {
      obj.corporate_officer = message.corporateOfficer;
    }
    if (message.italianFiscalCode !== undefined && message.italianFiscalCode !== null) {
      obj.italian_fiscal_code = message.italianFiscalCode;
    }
    if (message.usTaxPayer !== undefined && message.usTaxPayer !== null) {
      obj.us_tax_payer = message.usTaxPayer;
    }
    if (message.taxPayerOutsideLegalCountry !== undefined && message.taxPayerOutsideLegalCountry !== null) {
      obj.tax_payer_outside_legal_country = message.taxPayerOutsideLegalCountry;
    }
    if (message.domicileSameAsResidence !== undefined && message.domicileSameAsResidence !== null) {
      obj.domicile_same_as_residence = message.domicileSameAsResidence;
    }
    if (message.domicileLine1 !== undefined && message.domicileLine1 !== null) {
      obj.domicile_line_1 = message.domicileLine1;
    }
    if (message.domicileLine2 !== undefined && message.domicileLine2 !== null) {
      obj.domicile_line_2 = message.domicileLine2;
    }
    if (message.domicileZipcode !== undefined && message.domicileZipcode !== null) {
      obj.domicile_zipcode = message.domicileZipcode;
    }
    if (message.domicileCity !== undefined && message.domicileCity !== null) {
      obj.domicile_city = message.domicileCity;
    }
    if (message.domicileCountry !== undefined && message.domicileCountry !== null) {
      obj.domicile_country = message.domicileCountry;
    }
    if (message.sourcesOfWealth?.length) {
      obj.sources_of_wealth = message.sourcesOfWealth;
    }
    if (message.sourcesOfWealthOther !== undefined && message.sourcesOfWealthOther !== null) {
      obj.sources_of_wealth_other = message.sourcesOfWealthOther;
    }
    if (message.hasSourcesOfWealth !== undefined && message.hasSourcesOfWealth !== null) {
      obj.has_sources_of_wealth = message.hasSourcesOfWealth;
    }
    if (message.politicallyExposedPerson !== undefined && message.politicallyExposedPerson !== null) {
      obj.politically_exposed_person = message.politicallyExposedPerson;
    }
    if (message.nationalities?.length) {
      obj.nationalities = message.nationalities;
    }
    if (message.usPerson !== undefined && message.usPerson !== null) {
      obj.us_person = message.usPerson;
    }
    if (message.selfPepDeclaration !== undefined && message.selfPepDeclaration !== null) {
      obj.self_pep_declaration = message.selfPepDeclaration;
    }
    if (message.otherTaxIdentificationNumber !== undefined && message.otherTaxIdentificationNumber !== null) {
      obj.other_tax_identification_number = message.otherTaxIdentificationNumber;
    }
    if (message.otherTaxResidencyCountry !== undefined && message.otherTaxResidencyCountry !== null) {
      obj.other_tax_residency_country = message.otherTaxResidencyCountry;
    }
    if (message.usTaxIdentificationNumber !== undefined && message.usTaxIdentificationNumber !== null) {
      obj.us_tax_identification_number = message.usTaxIdentificationNumber;
    }
    if (message.providerCreated !== undefined && message.providerCreated !== null) {
      obj.provider_created = message.providerCreated;
    }
    if (message.identityId !== undefined && message.identityId !== null) {
      obj.identity_id = message.identityId;
    }
    if (message.uboConnectionToOrganization !== undefined && message.uboConnectionToOrganization !== null) {
      obj.ubo_connection_to_organization = message.uboConnectionToOrganization;
    }
    if (message.uboConnectionToOrganizationRaw !== undefined && message.uboConnectionToOrganizationRaw !== null) {
      obj.ubo_connection_to_organization_raw = message.uboConnectionToOrganizationRaw;
    }
    if (message.uboProviderStatus !== undefined && message.uboProviderStatus !== null) {
      obj.ubo_provider_status = apiUboProviderStatusToJSON(message.uboProviderStatus);
    }
    if (message.countriesOfSignificantRelationship?.length) {
      obj.countries_of_significant_relationship = message.countriesOfSignificantRelationship;
    }
    if (
      message.countryOfPredominantEconomicActivity !== undefined &&
      message.countryOfPredominantEconomicActivity !== null
    ) {
      obj.country_of_predominant_economic_activity = message.countryOfPredominantEconomicActivity;
    }
    return obj;
  },
};

function fromTimestamp(t: ApiTimestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(ApiTimestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
